import { MetaTags } from './types';

export const homepageMeta: MetaTags = {
    title: 'AI A/B Testing Without Subscriptions | TopUpTest',
    description:
        'Stop guessing what to test. Get AI-generated A/B test ideas and launch experiments in just a few clicks. Pay only for what you use.',
};
export const aboutMeta: MetaTags = {
    title: 'About TopUpTest | AI-Generated A/B Test Ideas & Simple Implementation',
    description:
        'Discover how TopUpTest uses AI to generate personalized A/B test ideas and empowers website owners to implement them simply—no coding required.',
};
export const freeCreditsMeta: MetaTags = {
    title: 'Free Recurring A/B Testing Sessions | TopUpTest',
    description:
        "Get free recurring A/B testing sessions with TopUpTest. Start optimizing your website's conversion rates without any cost. Explore our platform and see the results for yourself.",
};
export const blogMeta: MetaTags = {
    title: `TopUpTest Blog | A/B Testing Tips, Guides, Advice, How-to's and More`,
    description:
        'Explore the TopUpTest Blog for expert tips, guides, and advice on A/B testing. Discover how to optimize your website with how-to articles and the latest in conversion rate optimization.',
};
export const paymentInfoMeta: MetaTags = {
    title: 'Secure Payment Information for TopUpTest',
    description:
        'Trustworthy payment procedures at TopUpTest. Ensuring the security of your payment details. Explore our pricing plans for our affordable A/B testing software.',
};
export const contactMeta: MetaTags = {
    title: 'Contact TopUpTest for A/B testing Solutions',
    description:
        'Reach out to TopUpTest for inquiries or support. Professional assistance for your A/B testing needs. Discover how we empower businesses with our user-friendly platform.',
};
export const loginMeta: MetaTags = {
    title: 'TopUpTest Login',
    description:
        'Access your TopUpTest account. Streamlined login process for our A/B testing software. Begin optimizing conversions effortlessly with our platform.',
};
export const newPasswordMeta: MetaTags = {
    title: 'Create a New Password | TopUpTest Account',
    description:
        'Securely set up a new password for your TopUpTest account. Simple steps to ensure account security. Get back to optimizing your website with ease.',
};
export const resetPasswordMeta: MetaTags = {
    title: 'Reset Your Password | TopUpTest Account',
    description:
        'Effortlessly reset your TopUpTest account password. Hassle-free steps for account recovery. Resume your A/B testing journey promptly.',
};
export const newPasswordSuccessMeta: MetaTags = {
    title: 'Password Reset Success | TopUpTest',
    description:
        'Your password reset was successful. Get back to optimizing conversions with TopUpTest. Simplify A/B testing for your business.',
};
export const createAccountMeta: MetaTags = {
    title: 'Sign Up for AI-Generated A/B Test Ideas | TopUpTest',
    description:
        'Join TopUpTest to get AI-generated test ideas for your website and implement them effortlessly. Start optimizing conversions with session-based pricing—pay only for what you use.',
};
export const userDashboardMeta: MetaTags = {
    title: 'Your Dashboard for A/B testing | TopUpTest',
    description:
        'Access your personalized dashboard at TopUpTest. Manage and monitor your A/B tests effortlessly to enhance your website’s performance.',
};

export const qualifiedLeadSuccess: MetaTags = {
    title: 'Welcome to TopUpTest - Get AI Test Ideas Today | TopUpTest',
    description:
        'Welcome! Your account is ready. Get instant AI-generated A/B test suggestions and implement them with our simple platform. Pay only for sessions you use.',
};

export const standardLeadSuccess: MetaTags = {
    title: 'Account Created - Get Started with Your Free Testing | TopUpTest',
    description:
        'Your account has been created successfully. Begin your testing journey and unlock more features as you grow.',
};

export const userWebsitesMeta: MetaTags = {
    title: 'Manage Your Websites | TopUpTest A/B testing',
    description:
        'Effortlessly manage all your websites for A/B testing at TopUpTest. Optimize conversions across multiple sites with ease.',
};

export const userTestMeta: MetaTags = {
    title: 'View Individual Test | TopUpTest A/B testing',
    description:
        'Analyze and optimize individual tests with ease using TopUpTest. Gain insights to enhance your website’s performance effortlessly.',
};

export const userTestsMeta: MetaTags = {
    title: 'Your A/B tests | TopUpTest A/B testing',
    description:
        'Explore and manage all your A/B tests conveniently at TopUpTest. Drive conversions and engagement effectively with our user-friendly platform.',
};

export const testVariantMeta: MetaTags = {
    title: 'Analyze Test Variants | TopUpTest A/B testing',
    description:
        'Dive into individual test variants effortlessly with TopUpTest. Gain insights and optimize your website’s performance seamlessly.',
};

export const createTestMeta: MetaTags = {
    title: 'Start New A/B Test | TopUpTest',
    description:
        'Create a new A/B test with TopUpTest. Get AI-generated test ideas and implement them simply. Pay per session—only for the tests you run.',
};

export const testCreatedMeta: MetaTags = {
    title: 'Test Created Successfully | TopUpTest A/B testing',
    description:
        'Celebrate your success! Your A/B test has been created at TopUpTest. Start optimizing conversions hassle-free.',
};

export const testResultsMeta: MetaTags = {
    title: 'View Test Results | TopUpTest A/B testing',
    description:
        'Analyze your A/B test results conveniently at TopUpTest. Gain insights and optimize your website’s performance effortlessly.',
};

export const userPagesMeta: MetaTags = {
    title: 'Manage Your Pages | TopUpTest A/B testing',
    description:
        'Effortlessly manage your website pages for A/B testing at TopUpTest. Optimize conversions across multiple pages with ease.',
};

export const userProfileMeta: MetaTags = {
    title: 'Your Profile | TopUpTest A/B testing',
    description:
        'Manage your profile at TopUpTest. Personalize your experience and optimize conversions effortlessly with our user-friendly platform.',
};

export const userAvatarGoalsMeta: MetaTags = {
    title: 'Set Your Goals | TopUpTest A/B testing',
    description:
        'Define your goals for A/B testing success at TopUpTest. Tailor your strategy and drive conversions effectively.',
};

export const userAvatarBusinessMeta: MetaTags = {
    title: 'Optimize Business | TopUpTest A/B testing',
    description:
        'Enhance your business performance with TopUpTest. Utilize A/B testing to drive conversions and engagement efficiently.',
};

export const userAvatarDemographicsMeta: MetaTags = {
    title: 'Analyze Demographics | TopUpTest A/B testing',
    description:
        'Explore demographics for enhanced A/B testing insights at TopUpTest. Optimize conversions based on audience segmentation.',
};
export const userAvatarPreviousExperienceMeta: MetaTags = {
    title: 'Leverage Experience | TopUpTest A/B testing',
    description:
        'Utilize past experiences for A/B testing success at TopUpTest. Optimize conversions based on valuable insights.',
};

export const scriptSetupMeta: MetaTags = {
    title: 'Simple Script Setup | TopUpTest A/B testing',
    description:
        'Get your TopUpTest script running in minutes with our simple setup guide. No coding expertise required. Seamless integration for instant A/B testing.',
};

export const scriptVerificationMeta: MetaTags = {
    title: 'Verify Your Script | TopUpTest A/B testing',
    description:
        'Ensure script accuracy with TopUpTest. Use our script verification tools for confidence in your A/B testing setup.',
};

export const avatarProfileSuccessMeta: MetaTags = {
    title: 'Avatar Profile Created Successfully | TopUpTest A/B testing',
    description:
        'Congratulations! Your avatar profile has been created successfully at TopUpTest. Personalize your A/B testing experience.',
};

export const paymentSuccessMeta: MetaTags = {
    title: 'Payment Success | TopUpTest A/B testing',
    description:
        'Success! Your payment is confirmed at TopUpTest. Enjoy uninterrupted access to premium A/B testing features.',
};

export const paymentMethodUpdateSuccessMeta: MetaTags = {
    title: 'Payment Method Updated Successfully | TopUpTest A/B testing',
    description:
        'Your payment method has been updated successfully at TopUpTest. Continue optimizing your website with confidence.',
};

export const paymentMethodUpdateCancelledMeta: MetaTags = {
    title: 'Payment Method Update Cancelled | TopUpTest A/B testing',
    description:
        'Your payment method update has been cancelled at TopUpTest. Review your preferences and try again if needed.',
};

export const editAccountMeta: MetaTags = {
    title: 'Edit Your Account | TopUpTest A/B testing',
    description:
        'Customize your account details effortlessly at TopUpTest. Personalize your experience and optimize conversions hassle-free.',
};

export const styleGuideMeta: MetaTags = {
    title: 'Style Guide | TopUpTest A/B testing',
    description:
        'Explore the default styles of various elements with the TopUpTest Style Guide. Learn about our platform’s design principles.',
};

export const pageNotFoundMeta: MetaTags = {
    title: 'Page Not Found (404) | TopUpTest A/B testing',
    description:
        'Oops! The page you tried to load could not be found at TopUpTest. Navigate back or explore our other features.',
};

export const pageErrorMeta: MetaTags = {
    title: 'Page Error | TopUpTest A/B testing',
    description:
        'Something went wrong at TopUpTest. Our team is on it! Navigate back or contact support for assistance.',
};

export const supportMeta: MetaTags = {
    title: 'Get Support | TopUpTest A/B testing',
    description:
        'Explore support options at TopUpTest. Our team is here to assist you with any questions or issues regarding A/B testing.',
};

export const testCreationGuideMeta: MetaTags = {
    title: 'A/B Test Creation Guide with AI Ideas | TopUpTest A/B testing',
    description:
        'Learn how to create A/B tests with TopUpTest. Get AI-generated test suggestions and follow our guide to implement them simply and effectively.',
};

export const testExampleProductImageEffectivenessMeta: MetaTags = {
    title: 'Product Image Effectiveness A/B Test Example',
    description: 'Discover how to create a product image test by using our A/B testing platform.',
};

export const createFormTestMeta: MetaTags = {
    title: 'Landing Page Form A/B Test Example',
    description:
        'Discover how to create a landing page form test by using our A/B testing platform.',
};

export const privacyMeta: MetaTags = {
    title: 'Privacy Policy | TopUpTest A/B Testing Software',
    description:
        'Explore the TopUpTest Privacy Policy to understand how we collect, use, and protect data while helping you run privacy-conscious A/B tests.',
};

export const cookiesMeta: MetaTags = {
    title: 'Cookie Policy | TopUpTest A/B Testing Software',
    description:
        'Learn how TopUpTest uses cookies to improve website performance and enhance your A/B testing experience—all while respecting user privacy.',
};

export const termsMeta: MetaTags = {
    title: 'Terms & Conditions | TopUpTest A/B Testing Software',
    description:
        'Read the full Terms & Conditions for using TopUpTest. Understand your rights, obligations, and the rules for using our A/B testing platform.',
};

export const legalGuidanceMeta: MetaTags = {
    title: 'Legal Compliance Guidance for Customers | TopUpTest',
    description:
        'A practical guide to help TopUpTest customers stay legally compliant when running A/B tests and using our tracking script on their websites.',
};

export const dpaMeta: MetaTags = {
    title: 'Data Processing Agreement (DPA) | TopUpTest A/B Testing',
    description:
        'Review TopUpTest’s Data Processing Agreement outlining our commitments to data protection under GDPR and other privacy laws.',
};

export const liaMeta: MetaTags = {
    title: 'Legitimate Interests Assessment (LIA) | TopUpTest A/B Testing',
    description:
        'Read TopUpTest’s Legitimate Interests Assessment (LIA) explaining our lawful basis for non-personal data processing under GDPR.',
};

export const affiliateTermsMeta: MetaTags = {
    title: 'Affiliate Terms & Conditions | TopUpTest A/B Testing',
    description:
        'Understand the terms of our affiliate program at TopUpTest, including eligibility, commission structure, and promotional requirements.',
};

export const affiliateProgramMeta: MetaTags = {
    title: 'A/B Testing Affiliate Program | TopUpTest',
    description:
        'Sell our products to receive lifetime recurring commissions. Our affiliate program explained.',
};

export const partnershipsMeta: MetaTags = {
    title: 'CRO Partnership Program | TopUpTest',
    description:
        'Provide CRO or A/B testing services? Partner with us to receive ongoing commissions for anyone you refer to us.',
};

export const affiliateFaqMeta: MetaTags = {
    title: 'FAQs About Our Affiliate Program | TopUpTest',
    description:
        'Get answers to commonly asked questions about our affiliate program at TopUpTest. Learn how to maximize your affiliate journey with us!',
};

export const affiliateDashboardMeta: MetaTags = {
    title: 'Efficient Affiliate Dashboard | Monitor Conversions | TopUpTest',
    description:
        'Access your intuitive affiliate dashboard at TopUpTest to track and optimize conversions easily. Simplify your testing process today!',
};

export const referralListMeta: MetaTags = {
    title: 'Referral List for Affiliates | TopUpTest',
    description:
        'Check your affiliate referral list at TopUpTest to track your successes and optimize your marketing efforts. Start boosting conversions!',
};

export const affiliatePaymentsMeta: MetaTags = {
    title: 'Swift Affiliate Payments | Get Rewarded | TopUpTest',
    description:
        'Receive quick and reliable affiliate payments at TopUpTest. Join us and get rewarded for your contribution to conversion optimization!',
};

export const affiliateCommissionsMeta: MetaTags = {
    title: 'Earn Commissions | Boost Conversions | TopUpTest',
    description:
        'Maximize your earnings through affiliate commissions at TopUpTest. Start optimizing conversions and see your rewards grow!',
};

export const affiliateBalanceMeta: MetaTags = {
    title: 'Manage Affiliate Balance | TopUpTest',
    description:
        'Effortlessly manage your affiliate balance with ease at TopUpTest. Streamline your earnings and optimize conversions hassle-free!',
};

export const affiliateSessionsMeta: MetaTags = {
    title: 'Monitor Affiliate Sessions | TopUpTest',
    description:
        'Keep track of your affiliate sessions at TopUpTest to optimize your marketing strategies and drive better conversion rates. Start now!',
};

export const createAffiliateAccountMeta: MetaTags = {
    title: 'Simple Affiliate Account Creation | Join TopUpTest',
    description:
        'Create your affiliate account hassle-free with TopUpTest. Start optimizing conversions and boosting earnings today!',
};

export const affiliateLoginMeta: MetaTags = {
    title: 'Login to Your Affiliate Account | TopUpTest',
    description:
        'Access your affiliate account securely at TopUpTest. Begin optimizing conversions and maximizing your earnings effortlessly!',
};

export const pricingMeta: MetaTags = {
    title: 'PAYG A/B Testing Pricing Options | TopUpTest',
    description:
        'Explore our pay-as-you-go pricing options at TopUpTest for user-friendly A/B testing. Start optimizing conversions today!',
};

export const servicesMeta: MetaTags = {
    title: 'Custom A/B Testing Services | TopUpTest',
    description:
        'Want technical assistance with A/B testing? Explore our professional A/B testing services, from basic setup to custom development.',
};

export const abTestSuggesterMeta: MetaTags = {
    title: 'A/B Test Suggester Tool | TopUpTest',
    description:
        'Struggling to come up with A/B test ideas? Use our free A/B Test Suggester Tool to get personalized A/B test suggestions for your website.',
};

export const createTestFromPdfMeta: MetaTags = {
    title: 'Create AI-suggested A/B Test | TopUpTest',
    description:
        'Create an A/B test directly from an AI-generated test suggestion. Review the hypothesis, change, and metrics, then launch your test in minutes.',
};

export const quickWinsMeta: MetaTags = {
    title: 'STOP LEAKING CONVERSIONS! Download our Free Conversion Experiments Guide | TopUpTest',
    description:
        'Download your free guide to discover easy ways to improve your web pages with simple A/B tests.',
};

export const conversionTestIdeasPackMeta: MetaTags = {
    title: 'STOP LEAKING CONVERSIONS! Conversion Test Ideas Pack Download (free) | TopUpTest',
    description: `Discover practical conversion test ideas to elevate your website’s conversions with simple, actionable A/B experiments.`,
};

export const headlinesLandingPageMeta: MetaTags = {
    title: 'Compare What Converts Best | TopUpTest A/B Testing',
    description:
        'Claim Free Test - easily compare different product images, headlines, or other elements to see what drives the most conversions with TopUpTest.',
};

export const landingPageTemplateMeta: MetaTags = {
    title: 'HTML, CSS and JavaScript Landing Page Template Code Download',
    description:
        'Download this simple landing page template and amend it for use in your own projects. Includes the full HTML, CSS and JavaScript code.',
};

export const paidAdLandingPage: MetaTags = {
    title: 'AI-Generated A/B Test Ideas + Simple Implementation',
    description:
        'Get AI-generated test ideas for your website and implement them easily. TopUpTest makes A/B testing simple for anyone, with transparent PAYG pricing—no subscriptions required.',
};

export const paidAdAdvertisersLandingPage: MetaTags = {
    title: 'Improve Paid Ad Conversion Rates via A/B Testing',
    description:
        'Want to improve your paid ad conversion rates? Use A/B testing to test different parts of your landing pages to discover how to improve your CPA and ROAS.',
};

export const paidAdEcommerceLandingPage: MetaTags = {
    title: 'Boost Ecommerce Conversion Rates via A/B Testing',
    description:
        'Want to improve your eCommerce store conversion rates? Use A/B testing to test different parts of your pages to discover how to improve conversions.',
};

export const newNewsletterSubscriber: MetaTags = {
    title: 'New Subsciber',
    description: 'Congratulations on your subscription. You can now access your free content.',
};

export const blogTemplate: MetaTags = {
    title: '@todo',
    description: '@todo',
};

export const wordpressAndWoocommerceAbTesting: MetaTags = {
    title: 'WordPress and WooCommerce A/B Split Testing - Pluginless',
    description:
        'Ditch the plugin and just use a simple A/B testing platform to create tests for your WordPress with WooCommerce store.',
};

export const improveProductPageConversionsMeta: MetaTags = {
    title: 'Product Page Conversion Rate Optimization Ideas for A/B Testing',
    description:
        'Discover simple changes you can make to your product pages to improve conversion rates, then test which changes perform best with A/B testing to increase sales.',
};

export const abTestingHeadlinesMeta: MetaTags = {
    title: 'A Comprehensive Guide to A/B Testing Headlines | TopUpTest',
    description:
        'Discover the benefits, key elements, and best practices of A/B testing headlines. Learn how our A/B testing platform can help optimize your headlines for maximum engagement and conversions.',
};

export const abTestingMultipleVariantsMeta: MetaTags = {
    title: 'A/B Testing Multiple Variants with Multivariate Testing | TopUpTest',
    description:
        'Discover how A/B testing multiple variants can unlock deeper insights, faster optimizations, and significant improvements in your digital strategies.',
};

export const abTestingToolFree: MetaTags = {
    title: 'Free A/B Testing Tool for Websites | Split and Multivariate Testing',
    description: `The TopUpTest A/B testing platform can be used for free to make simple A/B tests for websites. It's based on simplicity and ease of use to all.`,
};

export const improveFormConversionsMeta: MetaTags = {
    title: 'Improve Form Conversion Rates with A/B Testing | TopUpTest',
    description: `Discover simple changes you can make to your forms to increase conversion rates, then test which changes perform best with A/B testing to boost submissions and reduce abandonment.`,
};

export const paymentFailedMeta: MetaTags = {
    title: 'Payment Failed | TopUpTest',
    description: 'Your payment attempt was unsuccessful at TopUpTest.',
};

export const createHeadlineMeta: MetaTags = {
    title: 'Create Headline A/B Tests Like the Pros | TopUpTest',
    description:
        'Learn how to craft powerful headline A/B tests with our free tutorial. Get inspired by experts like Alex Hormozi and see insights from top marketers.',
};

export const facebookAdOneMeta: MetaTags = {
    title: 'Free Headline A/B Test + 1000 Sessions | TopUpTest',
    description:
        'Create a simple headline A/B test to discover how A/B testing can transform your conversions.',
};

export const facebookAdTwoMeta: MetaTags = {
    title: 'PAYG-based A/B Testing Platform | TopUpTest',
    description:
        'Only pay for tests when you need them, on demand. Start with a Free Headline A/B Test + 1000 Sessions.',
};

export const facebookAdSevenMeta: MetaTags = {
    title: 'Compare What Converts Best | TopUpTest A/B Testing',
    description:
        'Claim Free Test - easily compare different product images, headlines, or other elements to see what drives the most conversions with TopUpTest.',
};

export const aiTestIdeasMeta: MetaTags = {
    title: 'Free A/B Test Ideas for Your Page | TopUpTest',
    description:
        'Enter your page URL to instantly generate AI-powered A/B test ideas. Preview a few high-impact experiments and download the full CRO report by signing up.',
};

export const shopifyAiTestIdeasMeta: MetaTags = {
    title: 'Free AI Shopify Conversion Ideas for Your Store | TopUpTest',
    description:
        'Enter your Shopify store URL to instantly generate AI-powered A/B test ideas. Preview a few high-impact experiments and download the full CRO report by signing up.',
};
